exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app[data-v-035ae332]{padding-top:0}.page-footer[data-v-035ae332]{position:absolute;bottom:0;width:100%;padding:.266667rem;background:#fff;box-sizing:border-box}.ellipsis-text[data-v-035ae332]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block;max-width:70%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-035ae332","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/survey/SurveyList.vue
// module id = 399
// module chunks = 0